// components/Footer.jsx
import { Github, Mail } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const Footer = () => {
  const { t } = useTranslation();
  return (
    <footer className="bg-gray-100 dark:bg-[#706F6F] border-t border-gray-200 dark:border-gray-700">
      <div className="max-w-6xl mx-auto px-4 py-6 flex flex-col sm:flex-row  gap-2 items-center justify-between text-sm text-gray-600 dark:text-gray-300">
        <div className="mb-2 sm:mb-0 text-black dark:text-white">
          © {new Date().getFullYear()}
         {t("footer")}
        </div>
        <div className="flex items-center justify-center gap-4 font-semibold ">
          <Link to="/WhyTrustUs" className="hover:underline">
            {t("nav4")}
          </Link>
          <Link to="/Faq" className="hover:underline">
            {t("nav5")}
          </Link>
          <Link to="/Contact" className="hover:underline">
            {t("nav6")}
          </Link>
          <Link to="/Patners" className="hover:underline">
            {t("nav7")}
          </Link>
        </div>
        <div className="flex items-center space-x-4">
          <a
            href="mailto:ndiangmarthe@data-check.org"
            className="hover:text-black dark:hover:text-white transition-colors"
          >
            <Mail className="w-5 h-5" />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
